import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const designerOptionsMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Designer Options',
		onClick: ({ context, controller }): void => {
			controller.publishShowProperties('design_options', context.id);
		}
	}
};
